import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createReturnViewFolder = {
  name: "createReturnViewFolder" as const,
  input: z.object({ name: z.string(), type: createEnum(ReturnTypeEnum) }),
  output: z.object({ folderId: z.string() }),
};
